import { useEffect, useRef } from "react";
import siteData from "../data/siteData.json";

function Projects() {
  const cloneRun = useRef(false);
  useEffect(() => {
    if (cloneRun.current) return;
    cloneRun.current = true;
    let items = document.querySelectorAll('.completed-projects .carousel .carousel-item')
    items.forEach((el) => {
      const minPerSlide = 4
      let next = el.nextElementSibling
      for (var i = 1; i < minPerSlide; i++) {
        if (!next) {
          // wrap carousel by using first child
          next = items[0]
        }
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
      }
    })
  }, []);

  const modalCloseRun = useRef(false);
  useEffect(() => {
    if (modalCloseRun.current) return;
    modalCloseRun.current = true;
    var modal = document.getElementById('id01');
    window.onclick = function(event) {
      if (event.target === modal) {
        modal.style.display = "none";
      }
    }
  }, []);

  const { projectsPage } = siteData;

  return (
    <>
      <header>
        <div id="carouselExampleCaptions" className="carousel slide hm-slider">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={siteData.heroBanner} className="d-block w-100" alt="..." />
            </div>
          </div>
        </div>
      </header>
      <section className="page-title mt-2">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-head text-left">
                <h1>OUR PROJECTS</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="project pt-5 pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="title">
                <h1>Ongoing Projects</h1>
              </div>
            </div>
            {projectsPage.map((project) => (
              <div className="col-md-4 mt-2 mb-3" key={project.modalId}>
                <div className="project-mas hover-shadow">
                  <div className="image-effect-one">
                    <img src={project.image} alt="" />
                    <div className="figcaption">
                      <button
                        type="button"
                        className="mfp-link"
                        data-bs-toggle="modal"
                        data-bs-target={`#${project.modalId}`}
                      >
                        <i className="fa fa-arrows-alt"></i>
                      </button>
                    </div>
                  </div>
                  <div className="project-info">
                    <h4>{project.name}</h4>
                    <p>{project.tagline}</p>
                    <p>{project.rera}</p>
                    <button className="ongo">
                      <a href="#" className="read">READ MORE</a>
                    </button>
                  </div>
                </div>
                <div
                  className="modal fade"
                  id={project.modalId}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby={`${project.modalId}Label`}
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id={`${project.modalId}Label`}>
                          {project.name}
                        </h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div
                          id={project.carouselId}
                          className="carousel slide carousel-fade"
                          data-bs-ride="carousel"
                        >
                          <div className="carousel-inner">
                            {project.carouselImages.map((img, index) => (
                              <div
                                className={`carousel-item${index === 0 ? " active" : ""}`}
                                key={img}
                              >
                                <img src={img} className="d-block w-100" alt="..." />
                              </div>
                            ))}
                          </div>
                          <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target={`#${project.carouselId}`}
                            data-bs-slide="prev"
                          >
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                          </button>
                          <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target={`#${project.carouselId}`}
                            data-bs-slide="next"
                          >
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Projects;